import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Common/withRouter";
import { createSelector } from 'reselect';
import jwt_decode from 'jwt-decode';


// users
import user1 from "../../../assets/images/users/avatar-1.jpg";

import { useSelector } from "react-redux";
import { IUserModel } from "models/User.Model";
import { ITokenModel } from "models/ITokenModel";
import CommonService from "services/CommonService";
import { aes_encryption, encryptOrderId, getLocalStorage } from "../../../helpers/Helper";
import { getDecodedAccessToken } from "../../../helpers/TokenHelper";

const ProfileMenu = (props: any) => {
  // Declare a new state variable, which we'll call "menu"
  let navigate = useNavigate();
  const [menu, setMenu] = useState(false);
  let token: string = localStorage.getItem("authUser") as string;
  const [detail, setDetail] = useState<IUserModel>();
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [profileImage, setProfileImage] = useState<any>();


  const [username, setusername] = useState("Admin");

  const profile = (state: any) => state.Profile;
  const selectProfileProperties = createSelector(
    profile,
    (success) => success,
  );

  const { success } = useSelector(selectProfileProperties);

  let PersonId = getDecodedAccessToken(getLocalStorage().Token)?.PersonId;
  // const encryptedUserId = aes_encryption(PersonId);

  const getMyAccount = (LoginId: number) => {
    CommonService.getWithSingleEntity('personModel', 'GetUser', PersonId).then((res) => {
      if (res.status === 200) {
        setDetail(res.data);
      }
    }).catch(e => {
      if (e == 'Request failed with status code 401') {
      navigate('/logout')
    } else {
      console.error("API error:", e);
    }
    });
  }

  const encryptedId = encryptOrderId(detail?.Id);

  const riderProfilePage = () => {
    window.location.href = "/profile/" + detail?.Id;
  }

  useEffect(() => {
    getMyAccount(PersonId);

  }, [])


  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        const obj = localStorage.getItem("authUser");
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        const obj = localStorage.getItem("authUser");
      }
    }
  }, [success]);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >

        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <Row>
            <Col>
              <div>
                <div className="avatar-xs mb-0">
                  <span className="avatar-title rounded-circle font-size-12 cursor-pointer bg-primary">
                    <text className="mt-0 fw-bold text-white fs-6">{detail?.FirstName.charAt(0).toUpperCase()}</text>
                  </span>
                </div>
              </div>

            </Col>
            {/* <Col>
              <span className="d-none d-xl-inline-block ms-2 me-1">{detail?.FirstName || "admin"}</span>
              <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
            </Col> */}
          </Row>

        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <DropdownItem tag="a" href={process.env.PUBLIC_URL + `/profile/${PersonId}`}>
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>
          {/* <DropdownItem tag="a" href={process.env.PUBLIC_URL + "/crypto-wallet"}>
            <i className="bx bx-wallet font-size-16 align-middle me-1" />
            {props.t("My Wallet")}
          </DropdownItem> */}
          {/* <DropdownItem tag="a" href="#">
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {props.t("Settings")}
          </DropdownItem> */}
          {/* <DropdownItem tag="a" href={process.env.PUBLIC_URL + "/auth-lock-screen"}>
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Lock screen")}
          </DropdownItem> */}
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(ProfileMenu));